/* eslint-disable no-restricted-globals */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { Button } from "reactstrap";
import moment from "moment";
import { toast } from "react-toastify";
import Timeout from "await-timeout";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import useFetcher from "../../../hooks/useFetcher";
import { handleErrors } from "../../../services/handleErrors";
import { getCandidatosByNP, postCandidatoNP } from "../../../services/candidatosNPServices";
import { getClosestDate } from "../createDerivacion/formNuevaDerivacion";
import { calcularFechaHabil } from "../../../pages/NotasDePedido/utils";
import NewCandidatoFormModal from "../../CandidatosNP/newCandidato/newCandidatoNpModal";
import { ButtonPrimary } from "../../../ui/buttons";
import { LabSelect } from "../../course/select";
import { CustomLabel } from "../../../ui/labels";
import { InputText, InputCheckboxContainer } from "../../../ui/inputs";
import { StylesDatePicker } from "../../../ui/stylesDatePicker";
import { formatearFecha } from "../../CandidatosNP/utils";
import ExistingCandidateModal from "../../CandidatosNP/existingCandidatoModal";

const FormEditDerivacion = ({
  toggle,
  info,
  handleEditDerivacion,
  vacantes,
  cobertura,
  notaDePedidoId,
  setReloadCandidatos,
  fechaAbierta,
  idsCandidatosDerivados = [],
  servicio,
  uploadOrPatchFilesCV,
  candidatosEnLaDerivacion = [],
}) => {
  const fechaActual = moment().format("YYYY-MM-DD");
  const fechaAbiertaNP = moment(fechaAbierta).format("YYYY,MM,DD");
  const [fechaDerivacionValue, setFechaDerivacionValue] = useState(fechaActual);
  const { id, cubiertas, candidatos, fechaDerivacion } = info;
  const coberturaExterna = cobertura - cubiertas;
  const [coberturaManual, setCoberturaManual] = useState(false);

  const [candidatosNp, isLoadingCandidatos, , , fetchCandidatos] = useFetcher(getCandidatosByNP, [notaDePedidoId]);
  const [candidatosList, setCandidatosList] = useState([]);
  const [candidatosADerivar, setCandidatosADerivar] = useState([]);
  const [candidatosModal, setCandidatosModal] = useState(false);
  const [candidatosCantidad, setCandidatosCantidad] = useState(0);
  const [fechaDeIngresoValue, setFechaDeIngresoValue] = useState(null);
  const [showExistingcandidate, setShowExistingcandidate] = useState(false);
  const [existingCandidateInfo, setExistingCandidateInfo] = useState({});
  const [descartarCandidatoRepetidos, setDescartarCandidatoRepetidos] = useState(null);

  useEffect(() => {
    if (descartarCandidatoRepetidos) {
      const candidatoADescartarId = descartarCandidatoRepetidos[0].id;
      setCandidatosList(candidatosList.filter((candidato) => candidato.id !== candidatoADescartarId));
      setCandidatosADerivar(candidatosADerivar.filter((candidato) => candidato.value.id !== candidatoADescartarId));
      fetchCandidatos();
      setReloadCandidatos(true);
    }
    setDescartarCandidatoRepetidos(null);
  }, [descartarCandidatoRepetidos]);

  // --------------------------------------------------------

  useEffect(() => {
    if (candidatosList.length) {
      setCandidatosCantidad(candidatosList.length);
    }
  }, [candidatosList]);
  const handleAddCandidato = async (candidatoData, files) => {
    try {
      const { message, result, repetidos } = await postCandidatoNP(candidatoData);
      if (repetidos) {
        toast.warn(message);
        setExistingCandidateInfo(result);
        setShowExistingcandidate(true);
      } else {
        if (files) await uploadOrPatchFilesCV(result.id, files);
        toast.success(message);
      }

      const label = repetidos ? `${candidatoData.nombre} ${candidatoData.apellido}` : `${result.nombre} ${result.apellido}`;
      const value = repetidos ? { id: result[0].id } : { id: result.id };
      setCandidatosList([...candidatosList, value]);
      setCandidatosADerivar([...candidatosADerivar, { label: `${label}`, value }]);
      fetchCandidatos();
      setReloadCandidatos(true);
      return true;
    } catch (error) {
      toast.error(error.message);
      return false;
    }
  };

  // filtra de las opciones de candidatos los que ya han sido derivados
  const candidatosFiltrados = candidatosNp.filter((candidato) => {
    return !idsCandidatosDerivados.includes(candidato.candidatoId);
  });

  const candidatosOptions = candidatosFiltrados
    .map((e) => {
      return { label: `${e.candidato.nombre} ${e.candidato.apellido}`, value: { id: e.candidatoId } };
    })
    .sort((a, b) => (a.label > b.label ? 1 : -1));

  const opcionesDisponibles = candidatosOptions.filter((opcion) => {
    return !candidatosADerivar.some((candidato) => candidato.value.id === opcion.value.id);
  });
  const handleReactSelectChange = (selected) => {
    setCandidatosADerivar(selected);
    setCandidatosList(selected.map((e) => e.value));
  };

  // --------------------------------------------------------
  const handleDatesChange = (values) => {
    const fechaFormateada = moment(values).format("YYYY-MM-DD");
    setFechaDerivacionValue(fechaFormateada);
  };

  const handleDatesChangeIngreso = (values) => {
    const fechaFormateada = moment(values).format("YYYY-MM-DD");
    setFechaDeIngresoValue(fechaFormateada);
  };

  const formik = useFormik({
    initialValues: {
      notaDePedidoId: id,
      fechaDerivacion,
      candidatos,
      cubiertas,
      candidatosDetalle: [{}],
    },
    onSubmit: async (values) => {
      const dataToDerivacion = {
        ...values,
        cubiertas: values.cubiertas ? JSON.parse(values.cubiertas) : cubiertas,
        candidatos: values.candidatos ? JSON.parse(values.candidatos) + candidatosCantidad : candidatos + candidatosCantidad,
        fechaDerivacion: fechaDerivacionValue,
        candidatosDetalle: candidatosList,
        fechaDeIngreso: fechaDeIngresoValue || null,
      };

      try {
        handleEditDerivacion(dataToDerivacion);
        await Timeout.set(1000);
        toggle();
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },
    validationSchema: Yup.object().shape({
      candidatos: Yup.number(),
      cubiertas: Yup.number().test("cubiertas", "El número de cubiertos  no puede superar a las vacantes solicitadas", (value) => {
        return value <= vacantes - coberturaExterna;
      }),
    }),
  });

  return (
    <>
      {showExistingcandidate && (
        <ExistingCandidateModal
          isOpen={showExistingcandidate}
          toggle={() => setShowExistingcandidate(!showExistingcandidate)}
          info={existingCandidateInfo}
          notaDePedidoId={notaDePedidoId}
          setReloadCandidatos={setReloadCandidatos}
          setDescartarCandidatoRepetidos={setDescartarCandidatoRepetidos}
        />
      )}
      <form className="theme-form" onSubmit={formik.handleSubmit}>
        <div className="row" style={{ display: "flex", justifyContent: "center" }}>
          <div className="col-sm-9 mb-3">
            <StylesDatePicker className="mb-1">
              <CustomLabel htmlFor="fechaAbierta" className="pt-0 w-100">
                Fecha de apertura
                <DatePicker
                  className="date-input digits w-100"
                  dateFormat="AAAA-MM-dd"
                  onChange={handleDatesChange}
                  disabled={formik.isSubmitting}
                  value={formatearFecha(fechaDerivacionValue)}
                  selected={fechaDerivacionValue ? new Date(fechaDerivacionValue).setDate(new Date(fechaDerivacionValue).getDate() + 1) : null}
                  maxDate={new Date()}
                  minDate={new Date(getClosestDate(fechaAbiertaNP, servicio))}
                />
              </CustomLabel>
            </StylesDatePicker>
          </div>
          <div className="col-sm-9">
            <div className="mb-3 mt-3">
              <CustomLabel className="pt-0 w-100 d-flex">
                Cobertura por candidatos
                <InputCheckboxContainer style={candidatosEnLaDerivacion && candidatosEnLaDerivacion.length > 0 ? { opacity: 0.5, pointerEvents: "none" } : null}>
                  <div className="checkbox-wrapper-19 ml-2">
                    <input
                      type="checkbox"
                      name="manual"
                      id="manual"
                      onChange={() => {
                        setCoberturaManual(!coberturaManual);
                      }}
                      disabled={formik.isSubmitting || (candidatosEnLaDerivacion && candidatosEnLaDerivacion.length > 0)}
                      checked={!coberturaManual}
                    />
                    <label htmlFor="manual" className="check-box m-0" />
                  </div>
                </InputCheckboxContainer>
              </CustomLabel>
            </div>
          </div>

          <NewCandidatoFormModal
            isOpen={candidatosModal}
            toggle={() => setCandidatosModal(!candidatosModal)}
            handleCreateCandidato={handleAddCandidato}
            notaDePedidoId={notaDePedidoId}
          />
          {coberturaManual ? (
            ""
          ) : (
            <div className="col-sm-9">
              <div className="form-group">
                <CustomLabel htmlFor="region" className="pt-0 w-100">
                  Candidatos
                  <LabSelect
                    isMulti
                    id="region"
                    name="region"
                    className="w-100"
                    onChange={handleReactSelectChange}
                    value={candidatosADerivar}
                    placeholder="Seleccionar candidatos"
                    isClearable
                    isLoading={isLoadingCandidatos}
                    options={opcionesDisponibles}
                  />
                  <div className=" mt-3 mb-0 d-flex justify-content-end">
                    <ButtonPrimary onClick={() => setCandidatosModal(!candidatosModal)} type="button">
                      Agregar otro
                    </ButtonPrimary>
                  </div>
                </CustomLabel>
              </div>
            </div>
          )}
          {coberturaManual ? (
            <>
              <div className="col-sm-9">
                <div className="form-group">
                  <CustomLabel htmlFor="candidatos" className="py-0 w-100">
                    Candidatos
                    <InputText
                      className="w-100 form-control"
                      // type="number"
                      name="candidatos"
                      disabled={formik.isSubmitting}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.candidatos}
                    />
                  </CustomLabel>
                  {formik.errors.candidatos && formik.touched.candidatos && <CustomLabel style={{ color: "red" }}>{formik.errors.candidatos}</CustomLabel>}
                </div>
              </div>
              <div className="col-sm-9">
                <div className="form-group">
                  <CustomLabel htmlFor="cubiertas" className="py-0 w-100">
                    Cubiertos
                    <InputText
                      className="w-100 form-control"
                      // type="number"
                      name="cubiertas"
                      disabled={formik.isSubmitting}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.cubiertas}
                    />
                  </CustomLabel>
                  {formik.errors.cubiertas && formik.touched.cubiertas && <CustomLabel style={{ color: "red" }}>{formik.errors.cubiertas}</CustomLabel>}
                </div>
              </div>

              <div className="col-sm-9">
                <StylesDatePicker className="mb-1">
                  <CustomLabel htmlFor="fechaAbierta" className="pt-0 w-100">
                    Fecha de ingreso
                    <DatePicker
                      placeholder="fecha de ingreso"
                      className="date-input digits w-100"
                      dateFormat="AAAA-MM-dd"
                      onChange={handleDatesChangeIngreso}
                      disabled={formik.isSubmitting}
                      value={fechaDeIngresoValue}
                      selected={fechaDeIngresoValue ? new Date(fechaDeIngresoValue).setDate(new Date(fechaDeIngresoValue).getDate() + 1) : null}
                      minDate={new Date(calcularFechaHabil(fechaActual, -1))}
                    />
                  </CustomLabel>
                </StylesDatePicker>
              </div>
            </>
          ) : (
            ""
          )}
        </div>
        <div className=" mt-3 mb-0 d-flex justify-content-end">
          <Button color="btn-secondary mr-2" onClick={toggle}>
            Cancelar
          </Button>
          <ButtonPrimary isLoading={formik.isSubmitting} disabled={formik.isSubmitting} type="submit">
            Editar Derivación
          </ButtonPrimary>
        </div>
      </form>
    </>
  );
};

export default FormEditDerivacion;
